import { render, staticRenderFns } from "./PushLink.vue?vue&type=template&id=02d3460c&scoped=true"
import script from "./PushLink.vue?vue&type=script&lang=js"
export * from "./PushLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d3460c",
  null
  
)

export default component.exports